import Phaser from "phaser";

/**
 * ReloadTimerBar UI component for showing reload progress.
 * Shows a yellow/orange bar that fills up as reload progresses.
 */
export class ReloadTimerBar {
  private scene: Phaser.Scene;
  private x: number;
  private y: number;
  private width: number;
  private height: number;
  public bar: Phaser.GameObjects.Graphics;
  public text: Phaser.GameObjects.Text;
  private progress: number = 0;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    width: number,
    height: number,
  ) {
    this.scene = scene;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;

    this.bar = scene.add.graphics();
    this.bar.setDepth(1001); // Same as health bar depth

    // Add "RELOADING" text above the bar
    this.text = scene.add.text(x + width / 2, y - 4, "RELOADING", {
      fontSize: "8px",
      color: "#ffaa00",
      fontFamily: "Arial",
      stroke: "#000000",
      strokeThickness: 2,
    });
    this.text.setOrigin(0.5, 1);
    this.text.setDepth(1001);

    this.drawBar();
  }

  /**
   * Sets the reload progress (0 to 1).
   */
  setProgress(progress: number) {
    this.progress = Phaser.Math.Clamp(progress, 0, 1);
    this.drawBar();
  }

  /**
   * Draws the reload timer bar.
   */
  private drawBar() {
    this.bar.clear();

    // Background (dark gray)
    this.bar.fillStyle(0x222222);
    this.bar.fillRect(this.x, this.y, this.width, this.height);

    // Progress bar (orange/yellow based on progress)
    const progressWidth = this.progress * this.width;
    if (progressWidth > 0) {
      // Gradient from red (0%) to yellow (50%) to green (100%)
      const color =
        this.progress < 0.5
          ? 0xff4400 // Red-orange at start
          : this.progress < 0.8
            ? 0xffaa00 // Orange-yellow in middle
            : 0xffff00; // Yellow at end

      this.bar.fillStyle(color);
      this.bar.fillRect(this.x, this.y, progressWidth, this.height);
    }
  }

  /**
   * Shows the reload timer bar.
   */
  show() {
    this.bar.setVisible(true);
    this.text.setVisible(true);
  }

  /**
   * Hides the reload timer bar.
   */
  hide() {
    this.bar.setVisible(false);
    this.text.setVisible(false);
  }

  /**
   * Destroys the reload timer bar.
   */
  destroy() {
    this.bar.destroy();
    this.text.destroy();
  }
}
